module.exports = __webpack_public_path__ + "static/media/pen-solid.473a7a25.svg";